import { CommonModule } from '@angular/common';
import { ConfigModule } from 'Angular/config/config.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TopPortfolioHoldingsComponent } from './top-portfolio-holdings.component';
import * as i0 from "@angular/core";
export class TopPortfolioHoldingsModule {
}
TopPortfolioHoldingsModule.ɵfac = function TopPortfolioHoldingsModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TopPortfolioHoldingsModule)(); };
TopPortfolioHoldingsModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: TopPortfolioHoldingsModule, bootstrap: [TopPortfolioHoldingsComponent] });
TopPortfolioHoldingsModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, ConfigModule, IconModule] });
